module.exports = __webpack_public_path__ + "img/bg.54100ac4.jpg";